import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';

/**
 * Project Repair Estimate from a high-level. Was built with intent to view-only.
 *
 * @see app/Http/Resources/Project/ProjectRepairEstimateResource.php
 */
export class ProjectRepairEstimate {
  constructor(
    public readonly exteriorsTotal: Nullable<number>,
    public readonly interiorsTotal: Nullable<number>,
    public readonly mepTotal: Nullable<number>,
    public readonly otherTotal: Nullable<number>,
    public readonly addersTotal: Nullable<number>,
    public readonly grandTotal: Nullable<number>,
    public readonly projectSqFt: Nullable<number>,
    public readonly totalPerSqFt: Nullable<number>,
  ) {}
}

defineTransform(ProjectRepairEstimate, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
  };
});
